// URL sanitization function
export const sanitizeUrl = (url: string): string => {
  try {
    // Remove any potentially dangerous characters and sequences
    let sanitized = url
      .replace(/[<>"']/g, '') // Remove XSS-prone characters
      .replace(/javascript:/gi, '') // Remove javascript protocol
      .replace(/data:/gi, '') // Remove data protocol
      .replace(/vbscript:/gi, '') // Remove vbscript protocol
      .replace(/file:/gi, '') // Remove file protocol
      .replace(/\s+/g, '') // Remove whitespace
      .trim()

    // Ensure the URL starts with http or https
    if (!sanitized.match(/^https?:\/\//i)) {
      // If it doesn't start with protocol, assume https
      sanitized = 'https://' + sanitized.replace(/^\/+/, '')
    }

    // Validate URL format
    const urlObj = new URL(sanitized)

    // Additional checks
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      throw new Error('Invalid protocol')
    }

    // Normalize the URL
    return urlObj.toString()
  } catch (error) {
    throw new Error('Invalid URL format')
  }
}
